import { TextLabel } from '@core/components/Inputs';
import { Competencia } from '@format/DATA';
import { Grid, Icon, Typography } from '@material-ui/core';
import React from 'react';
import { FaCheck } from 'react-icons/fa';
import { visualizacaoContratoStyles } from '../styles';

const PagamentoContratoVisualizacao = ({ contrato, getDescricaoFormaCobranca, getCurrency }) => {
  const styles = visualizacaoContratoStyles();

  const getDescricaoReajuste = (reajustarPor) => {
    let descricao = '';
    switch (reajustarPor) {
      case 'VALOR':
        descricao = 'Valor (R$)';
        break;
      case 'PERCENTUAL':
        descricao = 'Percentual (%)';
        break;
      default:
        descricao = 'Índice monetário';
    }
    return descricao;
  };

  const ReajusteAutomatico = () => {
    return (
      <>
        <Grid item xs={12} className={styles.iconText}>
          <Icon className={styles.icon}>
            <FaCheck size={14} />
          </Icon>
          <Typography id="aplicarReajusteAutomatico">Reajuste automático</Typography>
        </Grid>

        <Grid item xs={6}>
          <TextLabel
            id="reajustarPor"
            label="Reajustar contrato por"
            value={getDescricaoReajuste(contrato?.reajusteAutomatico?.reajustarPor)}
          />
        </Grid>
        {contrato?.reajusteAutomatico?.reajustarPor === 'INDICE' && (
          <Grid item xs={6}>
            <TextLabel
              id="indiceMonetario"
              label="Índice monetário"
              value={contrato?.reajusteAutomatico?.indiceMonetario}
            />
          </Grid>
        )}
        {contrato?.reajusteAutomatico?.reajustarPor === 'VALOR' && (
          <Grid item xs={6}>
            <TextLabel
              id="valorReajuste"
              label="Valor (R$)"
              value={getCurrency(contrato?.reajusteAutomatico?.valorReajuste)}
            />
          </Grid>
        )}
        {contrato?.reajusteAutomatico?.reajustarPor === 'PERCENTUAL' && (
          <Grid item xs={6}>
            <TextLabel id="valorReajuste" label="Percentual (%)" value={contrato?.reajusteAutomatico?.valorReajuste} />
          </Grid>
        )}
        <Grid item xs={6}>
          <TextLabel
            id="mesBaseReajuste"
            label="Mês base para reajuste"
            value={Competencia(contrato?.reajusteAutomatico?.mesBaseReajuste)}
          />
        </Grid>
        <Grid item xs={6}>
          <TextLabel
            id="periodicidadeMeses"
            label="Periodicidade de reajuste em meses"
            value={contrato?.reajusteAutomatico?.periodicidadeMeses}
          />
        </Grid>
      </>
    );
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={6}>
        <TextLabel
          id="vencimentoCobranca"
          label="Vencimento da cobrança"
          value={contrato?.vencimentoCobranca && `${contrato.vencimentoCobranca}º dia do mês`}
        />
      </Grid>
      <Grid item xs={6}>
        <TextLabel
          id="formaCobranca"
          label="Forma de recebimento"
          value={getDescricaoFormaCobranca(contrato?.formaCobranca)}
        />
      </Grid>
      <Grid item xs={6}>
        <TextLabel
          id="valorContratado"
          label="Valor mensal contratado (R$)"
          value={getCurrency(contrato?.valorContratado)}
        />
      </Grid>
      <Grid item xs={6}>
        <TextLabel id="valor" label="Valor mensal atual (R$)" value={getCurrency(contrato?.valor)} />
      </Grid>
      {contrato?.envioAutomaticoCobranca && (
        <Grid item xs={12} className={styles.iconText}>
          <Icon className={styles.icon}>
            <FaCheck size={14} />
          </Icon>
          <Typography id="envioAutomaticoCobranca">Envio automático</Typography>
        </Grid>
      )}
      {contrato?.enviarCobrancaEmail && (
        <Grid item xs={6} className={styles.iconText}>
          <Icon className={styles.icon}>
            <FaCheck size={14} />
          </Icon>
          <Typography id="enviarCobrancaEmail">Enviar cobrança por e-mail</Typography>
        </Grid>
      )}
      {contrato?.enviarNotaFiscalEmail && (
        <Grid item xs={6} className={styles.iconText}>
          <Icon className={styles.icon}>
            <FaCheck size={14} />
          </Icon>
          <Typography id="enviarNotaFiscalEmail">Enviar Nota Fiscal por e-mail</Typography>
        </Grid>
      )}
      {contrato?.emailsCliente?.length > 0 && (
        <Grid item xs={12}>
          <TextLabel
            id="0.emailPrincipal"
            label="E-mail principal do cliente"
            value={contrato?.emailsCliente[0]?.email}
          />
        </Grid>
      )}
      {contrato?.emailsCliente?.length > 1 && (
        <Grid item xs={12}>
          <b>E-mails adicionais</b>
          {contrato.emailsCliente.map((emailCliente, index) => {
            return index > 0 && <Typography id={`${index}.emailCliente`}>{emailCliente.email}</Typography>;
          })}
        </Grid>
      )}
      {contrato?.reajusteAutomatico?.aplicarReajusteAutomatico && <ReajusteAutomatico />}
    </Grid>
  );
};

export default PagamentoContratoVisualizacao;
